<template>
<div class="screencenter" style="height: 600px; width: 200px">
  <span style="font-weight: bold; font-size: 30px">Zugriff verweigert</span>
  <i style="margin-top: 30px; color: black" class="fas fa-lock fa-10x"></i>
  <span style="display: block;font-weight: bold;  margin-top: 20px">Es scheint ein Problem mit ihren Zugriffsrechten zu geben. Bitte loggen Sie sich erneut ein</span>
  <input v-if="showDebugInput" v-model="debugPassword" @keyup.enter="debugLogin" placeholder="Debug password" style="margin-top: 20px; padding: 5px;">
  </div>
</template>
<script>
import * as CASP from '../CASP.js'

export default {
  data() {
    return {
      showDebugInput: false,
      debugPassword: '',
      debugKeys: ''
    }
  },
  created: function () {
    document.getElementById('mainspinner').style.display = 'none'
    window.addEventListener('keydown', this.handleKeyPress)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress)
  },
  methods: {
    handleKeyPress(e) {
      this.debugKeys += e.key
      if (this.debugKeys.includes('logintrit')) {
        this.showDebugInput = true
        this.debugKeys = ''
      }
      if (this.debugKeys.length > 10) this.debugKeys = this.debugKeys.slice(-10)
    },
    debugLogin() {
      CASP.debugLogin(this.debugPassword, (status, response) => {
        if (status === 200) {
          this.$router.push('/')
        }
      })
    }
  }
}
</script>
